export enum TokenType {
  Guest = 'guest',
  Registered = 'registered',
}
